import type { FC, ReactNode, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';
import type { CompatibleCellChange, CompatibleChangeSource } from '@/components/UI/SpreadSheet/SpreadsheetV16';

import SpreadsheetV16, { type SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import { defaultMetadataToColumnSettingMapperV16 } from '@/support/hot-v16';
interface AnimalsTableV16Props {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetV16Settings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  patchMetadataAfterSettingsUpdated: () => void;
  maxRows: number;
  afterChange?: (changes: Array<CompatibleCellChange> | null, source: CompatibleChangeSource) => void;
  afterCreateRow?: (index: number, amount: number, source?: CompatibleChangeSource) => void;
  afterRemoveRow?: (source: CompatibleChangeSource | undefined) => void;
  afterValidation?: (
    isValid: boolean,
    value: ReactNode,
    row: number,
    prop: string | number,
    source: CompatibleChangeSource
  ) => void;
  setInvalid?: (invalid: boolean) => void;
  modalView?: boolean;
}

const AnimalsTableV16: FC<AnimalsTableV16Props> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  patchMetadataAfterSettingsUpdated,
  maxRows,
  afterChange,
  afterCreateRow,
  afterRemoveRow,
  afterValidation,
  setInvalid,
  modalView = false,
}) => {
  return (
    <SpreadsheetV16
      className="mt3"
      testPrefix="study-create-animals-v16"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapperV16}
      patchMetadataAfterSettingsUpdated={patchMetadataAfterSettingsUpdated}
      maxRows={maxRows}
      addCol
      afterChange={afterChange}
      afterCreateRow={afterCreateRow}
      afterRemoveRow={afterRemoveRow}
      afterValidation={afterValidation}
      setInvalid={setInvalid}
      modalView={modalView}
    />
  );
};

export default AnimalsTableV16;
